import { getSectionHeadingPath } from '/src/utils/apiFunctions';
import httpClient from '/src/utils/httpClient';
import { pathTypes } from '/src/utils/sectionEnums';

export function updateBlogApiCall({
  id,
  view,
  layout,
  isPathDesign,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,

  itemShadow,
  itemShadowColor,
  itemShape,
  itemOpacity,
  itemBorder,
  itemBorderColor,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.blog, isPathDesign), {
    id,
    view,
    layout,

    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,

    sectionBorderColor,
    sectionIsBackground,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,

    itemShadow,
    itemShadowColor,
    itemShape,
    itemOpacity,
    itemBorder,
    itemBorderColor,
  });
}
